import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import services from '../data/services';
import hubs from '../data/hubs';
import { buildProfessionalSchema } from '../utils/seo';

const CityFocusPage = ({ categoryKey }) => {
  const { city } = useParams();
  const normalizedCity = city?.toLowerCase();
  const service = services[categoryKey];

  if (!service || !hubs.includes(normalizedCity)) {
    return (
      <div className="min-h-screen bg-[#0a0a0a] text-white px-6 py-24">
        <Helmet>
          <title>City Focus Not Found | O'Brian Baxter</title>
          <meta name="robots" content="noindex" />
        </Helmet>
        <h1 className="text-5xl font-black">City Focus Not Found</h1>
        <p className="mt-4 text-zinc-400">The requested city or category is not configured yet.</p>
        <Link to="/" className="mt-6 inline-block text-[#00f3ff]">Return home</Link>
      </div>
    );
  }

  const cityLabel = normalizedCity.split('-').map((part) => part.charAt(0).toUpperCase() + part.slice(1)).join(' ');
  const pageUrl = `${window.location.origin}/#${window.location.pathname}`;

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-[#f7f6ed] px-6 py-24">
      <Helmet>
        <title>{service.name} — {cityLabel} | O'Brian Baxter</title>
        <meta name="description" content={`Local ${service.name} in ${cityLabel}. ${service.description}`} />
        <script type="application/ld+json">{JSON.stringify(buildProfessionalSchema({
            siteName: "O'Brian Baxter",
            description: `${service.name} in ${cityLabel}`,
            url: pageUrl
          }))}</script>
      </Helmet>

      <div className="max-w-5xl mx-auto">
        <h1 className="text-5xl md:text-7xl font-black uppercase tracking-tight">{service.name}</h1>
        <p className="mt-5 text-zinc-400 text-lg leading-relaxed">{service.description}</p>
        <div className="mt-10 grid md:grid-cols-3 gap-4">
          {service.highlights.map((item) => (
            <article key={item} className="p-5 border border-white/10 rounded-xl bg-zinc-900/30">
              <h3 className="text-sm uppercase tracking-widest text-zinc-300">{item}</h3>
            </article>
          ))}
        </div>

        <div className="mt-8 text-xs uppercase tracking-[0.35em] text-zinc-500">Twin Cities hub: {cityLabel}</div>
        <Link to="/" className="mt-8 inline-block text-[#00f3ff]">Back to Home</Link>
      </div>
    </div>
  );
};

export default CityFocusPage;
